"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const entity_1 = require("./../type/entity");
function getStateByContentIdUserId(states, contentId, userId) {
    const predicate = (s) => s.contentId === contentId && s.userId === userId;
    const state = states.find(predicate);
    return state;
}
exports.getStateByContentIdUserId = getStateByContentIdUserId;
function getIndexOfStateByContentIdUserId(states, contentId, userId) {
    const predicate = (s) => s.contentId === contentId && s.userId === userId;
    const stateIndex = states.findIndex(predicate);
    if (stateIndex < 0) {
        console.info('No state found in getIndexOfStateByContentIdUserId, contentId is', contentId, 'userId is', userId);
    }
    return stateIndex;
}
exports.getIndexOfStateByContentIdUserId = getIndexOfStateByContentIdUserId;
function getChildrenStatesForContentByUserId(states, content, userId) {
    const childrenContentIds = content.children.map((c) => c._id);
    return states.filter((s) => childrenContentIds.includes(s.contentId) && s.userId === userId);
}
exports.getChildrenStatesForContentByUserId = getChildrenStatesForContentByUserId;
function getStatesForUserIdAndContentIds(states, contentIds, userId) {
    const predicate = (s) => contentIds.includes(s.contentId) && s.userId === userId;
    const contentStates = states.filter(predicate);
    return contentStates;
}
exports.getStatesForUserIdAndContentIds = getStatesForUserIdAndContentIds;
function getWaitListStatesForUserIdAndContentIds(states, contentIds, userId) {
    const predicate = (s) => contentIds.includes(s.contentId) && s.userId === userId && s.registerType === entity_1.SessionRegisterType.WAITLISTED;
    const contentStates = states.filter(predicate);
    return contentStates;
}
exports.getWaitListStatesForUserIdAndContentIds = getWaitListStatesForUserIdAndContentIds;
//# sourceMappingURL=getState.js.map